import React from "react";

const Experience = ({ exp }) => (
  <div className="media mb-4" key={exp.company}>
    <span className="fa-stack fa-2x align-self-start">
      <i className="fas fa-square text-primary fa-stack-2x"></i>
      <i className="fas fa-briefcase fa-stack-1x text-dark mr-3"></i>
    </span>
    <div className="media-body text-white">
      <h5 className="mt-0">
        {exp.title} -<small className="font-italic"> {exp.company}</small>
      </h5>
      <small className="d-block text-light-gray mb-3">
        {exp.from} - {exp.to}
      </small>
    </div>
  </div>
);

export default Experience;
